import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=4379f30a&scoped=true&"
import script from "./AgentList.vue?vue&type=script&lang=js&"
export * from "./AgentList.vue?vue&type=script&lang=js&"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=4379f30a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379f30a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VIcon,
  VLayout,
  VTextField,
})
